import script from "./PoiLayersList.vue?vue&type=script&setup=true&lang=js"
export * from "./PoiLayersList.vue?vue&type=script&setup=true&lang=js"

import "./PoiLayersList.vue?vue&type=style&index=0&id=ecf936b2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecf936b2"]])

export default __exports__